const REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';

/**
 * Report the OS motion preference now and on every change; returns the unsubscribe. The in-app
 * Motion setting is separate; `Appearance.motionAllowed` combines both.
 */
export function watchSystemMotion(onChange: (allowed: boolean) => void): () => void {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
    onChange(true);
    return () => undefined;
  }
  const media = window.matchMedia(REDUCED_MOTION_QUERY);
  const report = () => onChange(!media.matches);
  report();
  media.addEventListener('change', report);
  return () => media.removeEventListener('change', report);
}
